<template>
<ListView
    ref="list"
    title="Knowledge Base"
    :show-id="false"
    :api-paging="false"
    :api-search="false"
    :api-delete="require('@/common/api').default.knowledgeDelete"
    :create-item-component="KnowledgeModalComponent"
    :create-item-component-props="{ onDocumentsUploaded: load }"
    :api-list="require('@/common/api').default.knowledge"
    :columns="[
        { title: 'Name', name: 'name', width: 150 },
        { title: 'Files', name: 'files', type: 'custom', width: 80 },
        { title: 'Text', name: 'text', type: 'custom' },
    ]"
    :menu-items="menuItems"
    @load="onListLoad">
    <template v-slot:custom="props">
        <div v-if="props.column.name === 'text'">
            <code v-if="props.item.text" class="m-0 text-break break-words text-wrap" >{{props.item.text.substring(0, 200)}} {{props.item.text.length > 200 ? '&#x2026;' : ''}}</code>
        </div>
        <div v-else-if="props.column.name === 'files'">
            <span>{{ filesCountFor(props.item) }}</span>
        </div>
    </template>
    <template v-slot:default>
        <KnowledgeModal ref="edit" :onDocumentsUploaded="load"></KnowledgeModal>
    </template>
</ListView>

</template>

<script>
import ListView from "@/views/templates/ListView.vue";
import KnowledgeModal from "@/components/local/KnowledgeModal.vue";

export default {
    computed: {
        KnowledgeModalComponent() {
            return KnowledgeModal;
        }
    },
    components: {
        ListView, KnowledgeModal
    },
    data() {
        return {
            loaded: false,
            selectedItem: null,
            filesByKnowledgeId: {},

            menuItems: [
                { title: "Edit", callback: this.updateStart }
            ]
        };
    },
    methods: {
        updateStart(item) {
            this.selectedItem = item;
            this.$refs.edit.openEdit(item, (_, close) => {
                close();
                this.load();
            });
        },
        load() {
            this.$refs.list.load();
        },
        onListLoad(data) {
            // data.files may contain all files with knowledge_id; build lookup for counts
            if (data && Array.isArray(data.files)) {
                const grouped = {};
                data.files.forEach(file => {
                    const knowledgeId = file.knowledge_id || file.knowledgeId;
                    if (!knowledgeId) {
                        return;
                    }
                    if (!grouped[knowledgeId]) {
                        grouped[knowledgeId] = [];
                    }
                    grouped[knowledgeId].push(file);
                });
                this.filesByKnowledgeId = grouped;
            } else {
                this.filesByKnowledgeId = {};
            }
        },
        filesCountFor(item) {
            if (item && Array.isArray(item.files)) {
                return item.files.length;
            }
            const knowledgeId = item && item.id;
            const filesForKnowledge = knowledgeId ? this.filesByKnowledgeId[knowledgeId] : null;
            return filesForKnowledge ? filesForKnowledge.length : 0;
        }
    }
};
</script>
